<template>
  <div id="wrapper">
    <h1 class="login-logo"><img src="/common/img/logo.png" alt="nanacara for Doctor" height="40"></h1>
    <div id="login-wrap">
      <slot />
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/js/components/Footer.vue'

export default {
  components: {
    Footer
  }
}
</script>
